export default __webpack_public_path__ + "static/media/logos_tarjetas_webpay_down.b3356d8e.png";